module.exports = __webpack_public_path__ + "img/chuzhizhong.50f20f26.png";